import { lazy, Suspense } from 'react';
import type { ReactNode } from 'react';
import type { RouteObject } from 'react-router-dom';

import { ProtectedRoute } from '@/auth/ProtectedRoute';
import { ROUTE_CHECKS } from '@/components/layout/admin-nav';
import { RouteErrorBoundary } from '@/components/RouteErrorBoundary';
import { RouteFallback } from '@/components/RouteFallback';

const Idis2goCustomersPage = lazy(() => import('./pages/Idis2goCustomersPage'));

function withSuspense(node: ReactNode): ReactNode {
  return <Suspense fallback={<RouteFallback />}>{node}</Suspense>;
}

/** IDIS2GO pages (System Admin), nested under the admin layout. */
export const oemRoutes: RouteObject[] = [
  {
    path: 'idis2go-customers',
    element: withSuspense(
      <ProtectedRoute requires={ROUTE_CHECKS.idis2go}>
        <Idis2goCustomersPage />
      </ProtectedRoute>,
    ),
    errorElement: <RouteErrorBoundary />,
  },
];
